module.exports = __webpack_public_path__ + "img/markdown.e36ea7b1.svg";